import Button from '../../../components/Button/Button';
import { textStyles } from '../../../constants/textStyles';

const ClientPaymentApprove = ({ onSubmit }) => {
  return (
    <div>
      <h1
        style={{
          ...textStyles.formTitle,
          marginBottom: 20,
        }}
      >
        ÐÐ»Ð¸ÐµÐ½Ñ ÑÐºÐ°Ð·Ð°Ð» ÑÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð²Ð·Ð½Ð¾ÑÐ° ÐºÐ°Ðº "ÐÐ¿Ð»Ð°ÑÐµÐ½Ð¾"
      </h1>

      <Button text={'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ'} fill onClick={onSubmit} />
    </div>
  );
};

export default ClientPaymentApprove;
